import * as React from 'react';
import {
	Link, Navigate, useNavigate, useLocation,
} from 'react-router-dom';

import { parseQuery } from '@common/typescript/utils/url';
import { defaultTransformFiltersBeforeHandleUrl, ItemsProvider } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import { getBackgroundUrl } from '@common/typescript/Utils';
import LoadMoreButton from '@common/react/components/Core/ItemsProvider/LoadMoreButton';

import { NTBaseItemOrItemsPage, NTPage } from '@commonTuna/react/objects/Page';

import { useReduxContext } from '@app/hooks/useReduxContext';
import { getPageInfo, getPageShortName } from '@app/components/Utils';

import '@app/scss/pages/blog.scss';

const Blog: React.FC = () => {
	const location = useLocation();
	const { blogPageId } = useReduxContext();

	const search = parseQuery(location.search);
	const defCurrent = +search.page || 1;
	const navigate = useNavigate();

	return <>
		{blogPageId > 0
			? (
				<ServerPageProvider<NTBaseItemOrItemsPage<NTPage>>
					path="blog"
					inner={(serverPage) => (
						<main>
							<div className="content-block">
								<div className="extra-text-block" style={{ margin: 0, padding: 0, marginTop: '32px' }}>
									<div className="clearfix">
										<ol className="breadcrumb pull-left">
											<li>
												<Link to="/">Home</Link>
											</li>
											<li className="active">Blog</li>
										</ol>
									</div>
									<h2>
										Blog
									</h2>
								</div>
								<div className="">
									<div className="sub-pages row">
										<ItemsProvider<NTPage>
											items={serverPage?.items?.list}
											pagination={{ current: defCurrent, pageSize: 10, total: serverPage?.items?.count }}
											loadRequest="blogArticlesViewListRemote"
											filters={{ page: defCurrent, id: blogPageId }}
											pageInSearch
											transformFiltersBeforeHandleUrl={(filters) => ({
												...defaultTransformFiltersBeforeHandleUrl(filters),
												page: filters.page || 1,
											})}
											render={(item) => {
												const info = item.langs && getPageInfo(item);

												return <div className="article clearfix" key={item.id}>
													<Link to={`/${item.fullPath}`} className="post">
														<h3 className="post__title">{getPageShortName(item)}</h3>
													</Link>
													{item.avatar && (
														<div
															className="sub-page__image"
															style={{ backgroundImage: getBackgroundUrl(`/remote/${item.avatar}`) }}
														/>
													)}
													<div className="external-html" dangerouslySetInnerHTML={{ __html: info ? info.shortBody : '' }} />
													<button
														type="button"
														className="article__link pull-right"
														onClick={() => navigate(`/${item.fullPath}`)}
													>
														Read more
													</button>
												</div>;
											}}
										>
											<div className="text-center">
												<LoadMoreButton className="more-button more-button__big mb10">
													Load More
												</LoadMoreButton>
											</div>
										</ItemsProvider>
									</div>
								</div>
							</div>
						</main>
					)}
				/>
			)
			: <Navigate to="/" />
		}
	</>;
};

export default Blog;
